import { Paper, Tab, Tabs, Typography } from "@material-ui/core";
import { useMemo } from "react";
import { Coupon } from "../../../graphql/models";
import {
  CouponUsageDetailsViewMode,
  useCouponUsageDetailsSharedStore,
} from "./coupon_usage_details_shared_store";

export type CouponUsageDetailsProps = {
  coupon: Coupon;
};

export function CouponUsageDetails(props: CouponUsageDetailsProps) {
  const { coupon } = props;
  const { setViewMode, viewMode } = useCouponUsageDetailsSharedStore();

  const usersTabEnabled = useMemo(
    () => (coupon.consumedByUsers ?? []).length > 0,
    [coupon.consumedByUsers]
  );
  const apartmentsTabEnabled = useMemo(
    () => (coupon.consumedByApartments ?? []).length > 0,
    [coupon.consumedByApartments]
  );

  return (
    <Paper square style={{ padding: "1rem" }}>
      <Typography variant="h4">
        Dettaglio utilizzo coupon {coupon.code}
      </Typography>
      <Tabs
        variant="fullWidth"
        value={viewMode}
        indicatorColor="primary"
        textColor="primary"
        onChange={(_, value) => setViewMode(value)}
      >
        <Tab
          value={CouponUsageDetailsViewMode.APARTMENTS}
          label="Appartamenti"
          disabled={!apartmentsTabEnabled}
        />
        <Tab
          value={CouponUsageDetailsViewMode.USERS}
          label="Utenti"
          disabled={!usersTabEnabled}
        />
        <Tab
          value={CouponUsageDetailsViewMode.RESERVATIONS}
          label="Prenotazioni"
        />
      </Tabs>
      <div
        style={{
          padding: "0.5rem",
          display: "flex",
          flexDirection: "column",
          gap: "0.5rem",
        }}
      >
        {viewMode === CouponUsageDetailsViewMode.APARTMENTS &&
          coupon.consumedByApartments?.map((consume) => (
            <span>{consume.apartmentCode}</span>
          ))}
        {viewMode === CouponUsageDetailsViewMode.RESERVATIONS &&
          coupon.consumedByReservations?.map((consume) => (
            <span>{consume.code}</span>
          ))}
        {viewMode === CouponUsageDetailsViewMode.USERS &&
          coupon.consumedByUsers?.map((consume) => (
            <span>{consume.fullName}</span>
          ))}
      </div>
    </Paper>
  );
}
